import { useCallback, useContext } from "react";
import { useMutation, useQueryClient, UseMutationOptions } from "react-query";
import { EntityType } from "../query-keys";

import type { IDeleteOrderParams } from "../domain";
import { apiServiceContext } from "../../api-service-context";

export const useDeleteOrder = (options?: UseMutationOptions<any, any, IDeleteOrderParams>) => {
  const { ordersApiService } = useContext(apiServiceContext);
  const queryClient = useQueryClient();

  const mutationFn = useCallback(
    (params: IDeleteOrderParams) =>
      ordersApiService.createCancellableRequest((cancelToken) =>
        ordersApiService.deleteOrder(params, cancelToken)
      ),
    [ordersApiService]
  );

  const mutation = useMutation<any, any, IDeleteOrderParams>(mutationFn, {
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries(EntityType.ORDERS);
      options?.onSuccess?.(...args);
    },
  });
  return mutation;
};
